<template>
    <div id="refundManage">
        <el-form ref="searchForm" :model="searchForm" style="width:100%" :inline="true" :label-position="labelPosition">
            <el-form-item style="width:100px;margin-bottom:15px">
                <el-select filterable v-model="searchForm.status" placeholder="请选择退款状态" clearable>
                    <el-option v-for="(item,index) in pickingStatusList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:160px;margin-bottom:15px">
                <el-input clearable v-model.trim="searchForm.orderNo" placeholder="订单编号"></el-input>
            </el-form-item>
             <el-form-item style="width:150px;margin-bottom:15px">
                <el-input clearable v-model.trim="searchForm.refundNo" placeholder="退款申请编号"></el-input>
            </el-form-item>
            <el-form-item style="width:150px;margin-bottom:15px">
                <el-select filterable clearable v-model.trim="searchForm.staffName" placeholder="申请人">
                    <el-option v-for="(item,index) in pickingUserAllList" 
                        :label="item.staffName" 
                        :value="item.staffName" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="width:350px;margin-bottom:15px">
                <el-date-picker
                    v-model="valueTime3"
                    type="daterange"
                    range-separator="-"
                    :default-time="['00:00:00', '11:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button v-if="basicsAuth.apply_refund" size="medium" type="success" @click="newModel()">新建</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                <!-- <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button> -->
            </el-form-item>
            <!-- <el-form-item class="fr">
                <el-col style="text-align:right">
                    <el-button v-if="basicsAuth.apply_refund" size="medium" type="success" @click="newModel()">新建</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item> -->
        </el-form>
        <el-card class="box-card fr" style="width: 100%;">
            <el-table
                :data="returnData"
                border
                id="tableId"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"                       
                    label="退款申请编号">
                    <template slot-scope="scope">
                        <span class="active-code" @click="checkModel(scope.row)">{{scope.row.refundNo}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="orderNo"
                    width="200"
                    label="关联订单号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="refundMoney"
                    label="退货金额(元)">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="退款状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == '2'">审核中</span>
                        <span v-if="scope.row.status == '3'">已退款</span>
                        <span v-if="scope.row.status == '4'">已驳回</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="staffName"
                    align="center"
                    label="申请人">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="createTime"
                    label="申请时间">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="refundReason"
                    label="退款原因">
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog :title="textModelMenu[dialogModelStatus]" :visible.sync="dislogModel" :close-on-click-modal="false" width="600px" :modal-append-to-body="false"  @close="emptyModelDialog()">
            <el-form ref="modelForm" :model="modelForm" label-width="100px" :label-position="labelPosition" :rules="modelFormRules" >
                <div v-if="!isReject">
                    <el-form-item label="关联工单" prop="orderNo">
                        <el-input clearable v-model.trim="modelForm.orderNo" placeholder="请输入关联工单(不超过30个字)" maxlength="30" :disabled="dialogModelStatus == 'update'"></el-input>
                    </el-form-item>
                    <el-form-item label="退款金额" prop="refundMoney">
                        <el-input clearable v-model.trim="modelForm.refundMoney" class="yuan" placeholder="请输入退款金额" oninput="this.value=this.value.replace(/\D/g,'').replace(/^0{1,}/g,'')" :disabled="dialogModelStatus == 'update'" maxlength="6"></el-input>
                    </el-form-item>
                    <el-form-item label="退款原因" prop="refundReason">
                        <el-input clearable type="textarea" v-model.trim="modelForm.refundReason" :disabled="dialogModelStatus == 'update'" placeholder="请输入退款原因(不超过500个字)" maxlength="500"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status" v-if="dialogModelStatus == 'update'">
                        <el-select filterable v-model.trim="modelForm.status" placeholder="请选择退款状态" style="width: 100%;" clearable disabled>
                            <el-option v-for="(item,index) in pickingStatusList"
                                :label="item.paraName"  
                                :value="item.paraCode" 
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="申请人" prop="staffName" v-if="dialogModelStatus == 'update'" >
                        <el-input clearable v-model.trim="modelForm.staffName" disabled></el-input>
                    </el-form-item>
                    <el-form-item  label="相关图片" v-if="dialogModelStatus == 'create'">
                        <el-upload
                            class="avatar-uploader"
                            ref="upload"
                            :data="postData"
                            :auto-upload="false"
                            action="https://up.qiniup.com"
                            list-type="picture-card"
                            :accept="acceptImage"
                            :on-success="handleModelAvatarSuccess"
                            :on-remove="handleRemove"
                            :on-preview="handlePreview"
                            :before-upload="beforeAvatarUpload">
                            <i class="el-icon-plus"></i>
                            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5Mb</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item  label="相关图片" v-if="dialogModelStatus == 'update'">
                        <el-upload
                            action="https://up.qiniup.com"
                            class="avatar-uploader hide-upload"
                            ref="update"
                            disabled
                            list-type="picture-card"
                            :file-list="fileList"
                            :on-preview="handlePreview">
                        </el-upload>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" v-if="dialogModelStatus == 'create' && !isReject" class="dialog-footer" >
                <el-button type="success" @click="getOrderListData">提交申请</el-button>
                <el-button @click="emptyModelDialog()">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <!--分页-->
        <el-col :span="24" class="toolbar">
            <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pages.pageSize"
                    layout="total, sizes, prev, pager, next,jumper"
                    :total="pages.total">
                </el-pagination>
            </div>
        </el-col>
    </div>
</template>
<script>
    let moment = require("moment");
    import { queryRefundList,applyRefund,checkRefund,getOrderList } from "../../api/order";
    import {queryUser} from '@/api/api';
    import store from '../../store/store';
    import {genUpToken} from "../basicSetting/com/qiniuToken.js";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'refundManage',
        data () {
            return {
                valueTime3:[],
                pickingStatusList:[
                    {
                        paraName:'全部',
                        paraCode:''
                    },
                    {
                        paraName:'审核中',
                        paraCode:'2'
                    },
                    {
                        paraName:'已退款',
                        paraCode:'3'
                    },
                    {
                        paraName:'驳回申请',
                        paraCode:'4'
                    }
                ],
                pickingRelativeList:[],
                pickingUserAllList:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    status:'',          //退款状态
                    orderNo:'',         //订单号
                    refundTimeFrom:'',  //申请开始时间
                    refundTimeTo:'',    //申请结束时间
                    staffName:'',       //申请人姓名
                    refundNo: '',       //退款申请编号
                },
                returnData: [],
                dislogModel:false,
                dialogModelStatus: "",
                textModelMenu: {
                    update: "退款申请详情",
                    create: "新建退款申请"
                },
                postData:{token:''},
                imageUrl: [],       //退款图片
                fileList:[],     //图片查看
                dialogImageUrl:"",  //预览图片
                dialogVisible: false,
                acceptImage: "image/jpeg,image/jpg,image/png",
                qiniuaddr: 'pic.allscs.cn',// 这是七牛云空间的外链默认域名
                ruleImg:'imageView2/0/q/75|imageslim',//规则
                isReject:false,
                modelForm:{
                    orderNo: '',
                    refundMoney: '',
                    refundReason: "",
                    images:"",
                },
                modelFormRules:{//validateRoleName
                    orderNo: [{ required: true, message: "请输入关联工单", trigger: "blur"}],
                    status: [{ required: true, message: "请选择退款类型", trigger: "blur" }],
                    refundMoney: [{ required: true, message: "请输入退款金额", trigger: "blur" }],
                    refundReason: [{ required: true, message: "请输入退款原因", trigger: "blur" }],
                },
                 basicsAuth:{
                    apply_refund:false
                }
               
            }
        },
        mounted () {
		 this.basicsAuth.apply_refund = getPermission('/api/workOrder/refund/apply_refund');
      
        },
        created(){
            var token = "";
            var policy = {};
            var bucketName = 'hohofast';
            var AK ='VYiFElH26Am5EbV9T3nACEfNt6xBRz6gEREDFlis';
            var SK = 'sFELHoXSwB8NpiWpPj2Wk7theJCO7Iil-2rwSj31';
            var deadline = Math.round(new Date().getTime() / 1000) + 3600;
            policy.scope = bucketName;
            policy.deadline = deadline;
            token=genUpToken(AK, SK, policy);
            this.postData.token=token;
            this.getRefundList();
            this.queryUserAllList();
        },
        methods: {
            //查询所有系统账号
            queryUserAllList(){
                queryUser({type:2}).then(res =>{
                    if(res.data.status == '100'){
                        this.pickingUserAllList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //上传成功
            handleModelAvatarSuccess(res, file) {
                this.imageUrl.push('http://' + this.qiniuaddr + '/' + res.key+'?imageslim');
                this.modelForm.images = this.imageUrl.join(',');
            },
            //删除图片
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            //预览图片
            handlePreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            //上传前判断
            beforeAvatarUpload(file) {
                const isPNG = file.type === 'image/png';
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 10;
                if (!isJPG&&!isPNG) {
                    this.$message.error('上传头像图片只能是 JPG 格式 和Png 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 10MB!');
                }
                return isLt2M;
            },
            //提交上传图片
            submitUpload() {
                this.imageUrl = [];
                this.$refs.upload.submit();
            },
            //获取关联订单号
            getOrderListData(){
                getOrderList({orderNo:this.modelForm.orderNo}).then(res => {
                    if (res.data.status==100) {
                        if(res.data.results.length == 0 ){
                            this.$message({
                                message: '关联工单号错误，请重新输入',
                                type: "warning"
                            });
                            
                        }else{
                            this.addModelFormSubmitBtn('modelForm');
                        }
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //关闭弹出框
            emptyModelDialog() {
                this.dislogModel = false;
                Object.keys(this.modelForm).forEach(key => this.modelForm[key]= '');
                this.$refs['modelForm'].resetFields();
                this.imageUrl = [];
                this.fileList = [];
                this.isReject = false;
            },
            //确定新建退款申请
            addModelFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: '提交中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.5)'
                        });
                        this.submitUpload();
                        const timer1 = setTimeout(()=>{
                            if(!this.modelForm.images){
                                this.$message({
                                    message: '请上传相关图片',
                                    type: "warning"
                                });
                                loading.close();
                            }else{
                                this.submitNewModel();
                                loading.close();
                                clearTimeout(timer1)
                            }
                        },1000)                    
                    }else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //提交申请
            submitNewModel(){
                applyRefund(this.modelForm).then(res => {
                    if (res.data.status==100) {
                        this.$message({
                            message: '申请退款成功',
                            type: "success"
                        });
                        /*关闭弹窗，重置输入框*/
                        this.emptyModelDialog();
                        /*刷新*/
                        this.getRefundList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            confirmBtn(num){
                let message = num == 0 ? '确认驳回申请吗？' : '确认退款已完成？';
                this.$confirm(message, '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    (num == 0) ? this.submitConfirmModel(0) : this.submitConfirmModel(1);
                }).catch(action => {
                    (num == 0) ? (this.isReject = false) : '';
                });
            },
            //退款确认 type:0 驳回 type:1确认
            submitConfirmModel(type){
                let para = {};
                if(type == 0){
                    if(!this.modelForm.attribute1){
                        this.$message({
                            message: '请输入驳回原因',
                            type: "warning"
                        });
                        return
                    }
                    para = {
                        id:this.modelForm.id,
                        status:"4",
                        attribute1:this.modelForm.attribute1
                    }
                }else{
                    para = {
                        id:this.modelForm.id,
                        status:"3",
                    }
                }
                checkRefund(para).then(res => {
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    if (res.data.status==100) {
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        /*关闭弹窗，重置输入框*/
                        this.emptyModelDialog();
                        /*刷新*/
                        this.getRefundList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                    loading.close();
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //新建退款
            newModel() {
                Object.keys(this.modelForm).forEach(key => this.modelForm[key]= '');
                this.dislogModel = true
                this.dialogModelStatus = "create";
            },
            //查看退款详情
            checkModel(item) {
                this.dislogModel = true
                this.dialogModelStatus = "update";
                this.modelForm = Object.assign({}, item);
                this.fileList = [];
                if(this.modelForm.images){
                    this.modelForm.images.split(',').forEach((item,index)=>{
                        this.fileList.push({
                            name:'',
                            url:item
                        })
                    })
                }
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.valueTime3 = [];
                this.getRefundList();
            },
            //获取退款申请管理列表
            getRefundList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                queryRefundList(this.searchForm).then(res => {          
                    if (res.data.status==100) {            
                            this.returnData = res.data.results.list
                            this.returnData.forEach((item,index)=>{
                                item.createTime = this.filters.formatDate(item.createTime)
                            })
                            this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getRefundList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getRefundList()
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(!this.valueTime3){
                            this.searchForm.refundTimeFrom = ''
                            this.searchForm.refundTimeTo = ''
                        }else if (this.valueTime3.length == 0) {
                            this.searchForm.refundTimeFrom = ''
                            this.searchForm.refundTimeTo = ''
                        }else{
                            this.searchForm.refundTimeFrom = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                            this.searchForm.refundTimeTo = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                        }
                        this.getRefundList()
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    .hide-upload{
        .el-upload {
            display: none;
        }
    } 
    #refundManage{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
        .active-code{
            color:#409EFF
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }

</style>



// WEBPACK FOOTER //
// refundManage.vue?f08b4fb0